<template>
  <div class="home-about-item team">
    <div class="home-item-left">
      <placed-image url="img/team_medley.jpg" />
    </div>
    <div class="home-item-right">
      <editable-item page="home" item="team" :loaded="storiesLoaded" />
      <div class="b-panel">
        <ix-router-link class="bigbutton" to='/about'>{{ $nippets.home.seeMore }}</ix-router-link>
      </div>
    </div>
    <div class="home-item-far-right">
      <div class="imblock">
        <img src="../../../assets/img/redxicon.svg" class="multiply" />
      </div>
    </div>
  </div>

</template>

<script>
import PlacedImage from '@/components/widgets/PlacedImage.vue'
import EditableItem from '@/components/editors/EditableItem.vue'
import ViewablePanel from '@/mixins/ViewablePanel.js'

export default {
  mixins:[ ViewablePanel ],
  components:{
    PlacedImage,
    EditableItem
  },
  data () {
    return {
      storiesLoaded: false
    }
    
  },
  methods: {
    async init () {
      this.$k.fetchStories('home', () => {
        this.storiesLoaded = true
      })
    }
  },
  watch: {
    seen () {
      this.init()
    }
  }
}
</script>

<style>
.home-about-item.team{
  background-image:url('../../../assets/img/globe_1.svg');
  background-size:contain;
  background-position: center center;
}
</style>